// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d54508e1","498":"3ba84dc0","703":"553fd3f4"}[chunkId] + ".chunk.js";
};